// Action
const SHOW = 'tutorial/show';
const HIDE = 'tutorial/hide';
// Action Creator
export const show = () => {
    return {
        type: SHOW,
    };
};
export const hide = () => {
    return {
        type: HIDE,
    };
};
const initialState = {
    shouldShow: false,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case SHOW: {
            return Object.assign(Object.assign({}, state), { shouldShow: true });
        }
        case HIDE: {
            return Object.assign(Object.assign({}, state), { shouldShow: false });
        }
        default: {
            return state;
        }
    }
};
